import { BlobPrinterService } from "src/app/services/print/blob/blob-printer.service";
import { downloadBlob } from "src/app/support/blob";

import { sntLog } from "src/app/common/logger";

const logger = sntLog("MobileBlobPrinterService");
export class MobileBlobPrinterService extends BlobPrinterService {
  print({ blob, name }: { blob: Blob; name: string }): Promise<void> {
    return new Promise<void>(async (res, rej) => {
      try {
        await downloadBlob(blob, name);
        res();
      } catch (ex) {
        logger.error(ex);
        rej(ex);
      }
    });
  }
}
